export const isReactSnap = () =>
  typeof window !== 'undefined' && window.navigator.userAgent === 'ReactSnap';

export const isServer = () => typeof window === 'undefined';

export const isDevelopment = () =>
  process.env.NODE_ENV === 'development' ||
  typeof window === 'undefined' ||
  window.location.hostname === 'localhost' ||
  isReactSnap();
